import { render } from "./Departments.vue?vue&type=template&id=27e7040e&scoped=true"
import script from "./Departments.vue?vue&type=script&lang=js"
export * from "./Departments.vue?vue&type=script&lang=js"

import "./Departments.vue?vue&type=style&index=0&id=27e7040e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e7040e"]])

export default __exports__